export default {"src":"/_next/static/media/laptop.3f34baf9.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};